var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleExclaimationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1rem",
    height: "1rem",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0.75C3.61719 0.75 0.5 3.89453 0.5 7.75C0.5 11.6328 3.61719 14.75 7.5 14.75C11.3555 14.75 14.5 11.6328 14.5 7.75C14.5 3.89453 11.3555 0.75 7.5 0.75ZM6.84375 4.90625C6.84375 4.55078 7.11719 4.25 7.5 4.25C7.85547 4.25 8.15625 4.55078 8.15625 4.90625V8.40625C8.15625 8.78906 7.85547 9.0625 7.5 9.0625C7.11719 9.0625 6.84375 8.78906 6.84375 8.40625V4.90625ZM7.5 11.6875C7.00781 11.6875 6.625 11.3047 6.625 10.8398C6.625 10.375 7.00781 9.99219 7.5 9.99219C7.96484 9.99219 8.34766 10.375 8.34766 10.8398C8.34766 11.3047 7.96484 11.6875 7.5 11.6875Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleExclaimationIcon);
export default __webpack_public_path__ + "static/media/circle-exclaimation-icon.b4ced5cafd8333144baa9c8510d63145.svg";
export { ForwardRef as ReactComponent };